import { createContext, useContext } from 'react';

interface PanelErrorBoundaryContextValue {
  onClose?: () => void;
}

const PanelErrorBoundaryContext = createContext<PanelErrorBoundaryContextValue>({});

export const PanelErrorBoundaryProvider = PanelErrorBoundaryContext.Provider;

export const usePanelErrorBoundaryContext = () => useContext(PanelErrorBoundaryContext);
